The identifier for the HTTP request.

This is included in the request as an `X-Request-Id` custom header.
